import React, { useState } from 'react';

import styled from '@emotion/styled';

import SelectorDropDown from '../../../components/DropDown/SelectorDropDown';
import Tooltip from '../../../components/Tooltip/Tooltip';
import DistributionInsight from './DistributionInsight';
import DriverPerformanceData from './DriverPerformanceData';

const IncidentDistribution = () => {
  const [distribution, setDistribution] = useState<string>('Incident Report');

  return (
    <Container>
      <HeaderArea>
        <Header>
          Incident Distribution{' '}
          <Tooltip content='Real-time incident analytics and insights' />
        </Header>

        <ControlArea>
          <SelectorDropDown
            activeField={distribution}
            setActiveField={setDistribution}
            options={['Distribution insights', 'Incident Report']}
          />
        </ControlArea>
      </HeaderArea>

      {distribution === 'Incident Report' ? (
        <DriverPerformanceData />
      ) : (
        <DistributionInsight />
      )}
    </Container>
  );
};

export default IncidentDistribution;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 24px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const HeaderArea = styled.div`
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;

  margin-bottom: 18px;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
`;

const ControlArea = styled.div`
  display: flex;
  width: fit-content;
  margin-left: auto;
`;
